export const isIdIncludes = (list, id, strict) => {
  if (!list) {
    return false;
  }
  const result = list.find((elem) => {
    if (strict) {
      return elem === id;
    }
    return elem.slice(0, id.length) === id;
  });
  return !!result;
};

export const generateIdList = (images) => {
  const ids = {
    images: images.map((i) => {
      const tags = [
        'rect', 'path', 'circle', 'ellipse', 'textPath',
        'text', 'g', 'line', 'polyline', 'polygon'];
      return tags.map((tag) => {
        const nodes = i.querySelectorAll(`${tag}[id]`);
        return { tag, ids: Array.from(nodes).map((node) => node.getAttribute('id')).sort() };
      });
    }),
    fullList: [],
  };

  const fullList = [];
  ids.images.forEach((item) => {
    item.forEach((elem) => {
      fullList.push(...elem.ids);
    });
  });
  const collator = new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' });
  ids.fullList = [...new Set(fullList)].sort(collator.compare);
  return ids;
};

export const getTagIds = (list, tags) => {
  if (!list || list.length === 0) {
    return [];
  }
  const preList = [];
  list.images.forEach((image) => {
    image.forEach((elem) => {
      if (typeof tags === 'string') {
        if (elem.tag === tags) {
          preList.push(...elem.ids);
        }
      }
      if (Array.isArray(tags)) {
        if (tags.includes(elem.tag)) {
          preList.push(...elem.ids);
        }
      }
    });
  });
  return [...new Set(preList)].sort();
};

export const getImagesIds = (images) => {
  const list = images.map((i) => {
    const tags = [
      'rect', 'path', 'circle', 'ellipse', 'textPath',
      'text', 'g', 'line', 'polyline', 'polygon'];
    return tags.map((tag) => {
      const nodes = i.querySelectorAll(`${tag}[id]`);
      return { tag, ids: Array.from(nodes).map((node) => node.getAttribute('id')).sort() };
    });
  });
  const fullList = [];
  list.forEach((item) => {
    item.forEach((elem) => {
      fullList.push(...elem.ids);
    });
  });
  list.fullList = [...new Set(fullList)].sort();
  return fullList;
};
